import { CellProps } from 'react-table';

import { Camera } from 'types/camera';

import { useDeleteCameras } from 'cameras/hooks/useDeleteCameras';
import { useModal } from 'hooks/useModal';

import {
  ContextMenu,
  ContextMenuAction,
} from 'components/ContextMenu/ContextMenu';
import { IconButton } from 'components/IconButton/IconButton';

export type CamerasTableActionsCellProps = CellProps<Camera> & {
  onRenameClick: (cameraId: string) => void;
};

export function CamerasTableActionsCell({
  row,
  onRenameClick,
}: CamerasTableActionsCellProps) {
  const { open } = useModal();

  const { mutateAsync: deleteCameras } = useDeleteCameras();

  function handleRenameClick() {
    onRenameClick(row.original.id);
  }

  function handleDeleteClick() {
    open('confirm-delete', {
      title: `Are you sure you want to delete ${row.original.name}?`,
      onConfirm: () => deleteCameras({ camera_ids: [row.original.id] }),
    });
  }

  return (
    <div className="columns halign-end">
      <ContextMenu
        trigger={
          <IconButton
            icon="more-vertical"
            label="Reveal more actions"
            variant="ghost"
          />
        }
      >
        <ContextMenuAction icon="text" onClick={handleRenameClick}>
          Rename
        </ContextMenuAction>
        <ContextMenuAction
          icon="delete"
          onClick={handleDeleteClick}
          intent="danger"
        >
          Delete
        </ContextMenuAction>
      </ContextMenu>
    </div>
  );
}
